import {
  startAuthentication,
  startRegistration,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";
import { apiFetch } from "./api";

export async function registerPasskey(): Promise<void> {
  const { options } = await apiFetch<{
    options: PublicKeyCredentialCreationOptionsJSON;
  }>("/auth/passkey/register/options", { method: "POST", body: "{}" });
  const response = await startRegistration({ optionsJSON: options });
  await apiFetch("/auth/passkey/register/verify", {
    method: "POST",
    body: JSON.stringify({ response }),
  });
}

export async function signInWithPasskey(email: string): Promise<{
  token: string;
  user: { email: string; name: string };
  redirectTo?: string;
}> {
  const { options } = await apiFetch<{
    options: PublicKeyCredentialRequestOptionsJSON;
  }>("/auth/passkey/login/options", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
  const response = await startAuthentication({ optionsJSON: options });
  return apiFetch("/auth/passkey/login/verify", {
    method: "POST",
    body: JSON.stringify({ email, response }),
  });
}

export async function listPasskeys(): Promise<Array<{ id: string }>> {
  const data = await apiFetch<{ passkeys: Array<{ id: string }> }>("/auth/passkeys");
  return data.passkeys ?? [];
}

export async function removePasskey(id: string): Promise<void> {
  await apiFetch(`/auth/passkeys/${id}`, { method: "DELETE" });
}
